import { useEffect } from 'react'
import { useLocation, useRouteMatch } from 'react-router-dom'
import { Loader } from '@calendly/ui/components/loader'
import { MainPanel } from '@calendly/booking-kit'

import Container from 'components/layout/container'
import ContentWrapper from 'components/layout/content_wrapper'
import GoogleAnalytics from 'services/analytics/google'
import FbPixel from 'services/analytics/facebook_pixel'
import EmbedAnalytics from 'services/analytics/embed'
import { SchedulingLinkContainer } from 'components/scheduling_links'
import { useProfile } from 'components/use_profile'
import { useGetEventTypesQuery, useGetPublicPackagesQuery } from 'root-api'
import ErrorAlert from 'components/error/alert'

import Dossier from './dossier'
import EventTypes from './event_types'
import Packages from './packages'
import { LandingPageWrapper } from './landing_page_wrapper'
import { Bricks, CookieSettingsButton } from './styles'

export default function SelectEventType() {
  const { search: searchString } = useLocation()
  const profileSlug = useRouteMatch().params.profileSlug
  const profile = useProfile()

  const {
    data: eventTypes,
    isLoading: eventTypesLoading,
    isError: eventTypesError
  } = useGetEventTypesQuery({ slug: profileSlug })

  const {
    data: packages,
    isError: packagesError
  } = useGetPublicPackagesQuery({ slug: profileSlug })

  useEffect(() => {
    GoogleAnalytics.userTrackEvent('invitee_scheduling_page')
    FbPixel.trackCustom('invitee_scheduling_page')
    EmbedAnalytics.track('profile_page_viewed')
  }, [])

  if (!profile) return null

  if (profile.is_landing_page) {
    return (
      <SchedulingLinkContainer expanded>
        <LandingPageWrapper />
      </SchedulingLinkContainer>
    )
  }

  if (eventTypesLoading) {
    return (
      <Container expanded>
        <MainPanel>
          <ContentWrapper>
            <Dossier />
            <Loader />
          </ContentWrapper>
        </MainPanel>
      </Container>
    )
  }

  if (eventTypesError) {
    return (
      <Container expanded>
        <MainPanel>
          <ContentWrapper>
            <Dossier />
            <ErrorAlert
              error={{}}
              buttonClick={() => window.location.reload()}
            />
          </ContentWrapper>
        </MainPanel>
      </Container>
    )
  }

  return (
    <Container expanded>
      <MainPanel>
        <ContentWrapper>
          <Dossier />
          <Bricks>
            <EventTypes eventTypes={eventTypes} searchString={searchString} />
            <Packages offerings={packages} isError={packagesError} />
          </Bricks>
          <CookieSettingsButton />
        </ContentWrapper>
      </MainPanel>
    </Container>
  )
}
